// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"375":"e4eca649","453":"500af1f8","606":"f436a049","737":"99520414","947":"a15f6c66"}[chunkId] + ".chunk.js";
};